/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetEditDialog.vue?vue&type=template&id=a21a9f12&scoped=true"
import script from "./widgetEditDialog.vue?vue&type=script&lang=js"
export * from "./widgetEditDialog.vue?vue&type=script&lang=js"
import style0 from "./widgetEditDialog.vue?vue&type=style&index=0&id=a21a9f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21a9f12",
  null
  
)

export default component.exports